import React from 'react';
import PropTypes from 'prop-types';
import Config from '../../Config';
import * as amplitude from '../../lib/amplitude';
import * as summaryRowTypes from './summaryRowTypes';

const config = new Config();

const amplitudeInfoToEditValues = {
  '/account-type': 'account_setup',
  '/personal-info': 'personal_information',
  '/employment': 'employment_information',
  '/financial': 'suitability',
  '/equities-account-settings': 'options_level',
  '/additional-info': 'trusted_contact',
  '/documents': 'upload_documents',
};

const SummaryDetailValue = (props) => {
  const {
    keyValue,
    valueType,
    value,
    authToken,
    canEdit,
    editClasses,
    editLink,
    applicationId,
    registration,
    application,
    accountType,
  } = props;

  const handleTrackEvent = () => {
    const fdcnId = registration.fdcnId;
    const isTseu = application && application.isTSEU;
    const eventProperties = {
      application_id: applicationId,
      relationship_status: registration.isExistingCustomer ? 'returning' : 'new',
      info_to_edit: amplitudeInfoToEditValues[editLink],
      tradestation_entity: isTseu ? 'tseu' : 'tss',
      account_type: amplitude.mapAccountType2(accountType),
    };
    amplitude.trackEvent('aop_summary_edited', eventProperties, fdcnId);
  };

  switch (valueType) {
    case summaryRowTypes.SUMMARY_ROW_TXT:
      return (
        <div key={`value_${keyValue}`} className="col-xs-6">{value}</div>
      );
    case summaryRowTypes.SUMMARY_ROW_BOX: {
      const boxes = value.split('||').map((subValue) => {
        return <span key={`value_${keyValue}_${subValue}`} className="label label-success">{subValue}</span>;
      });
      return (
        <div key={`value_${keyValue}`} className="col-xs-6">
          {boxes}
        </div>
      );
    }
    case summaryRowTypes.SUMMARY_ROW_FILE: {
      const docs = JSON.parse(value);
      const files = docs.map((doc) => {
        return (
          <a
            key={`value_${keyValue}_${doc.documentId}`}
            target="_blank"
            rel="noopener noreferrer"
            href={`${config.apiUrl}${doc.documentPath}?access_token=${authToken}`}
          >
            <i className="material-icons">attach_file</i>
          </a>
        );
      });
      return (
        <div key={`value_${keyValue}`} className="col-xs-6">
          {files}
        </div>
      );
    }
    case summaryRowTypes.SUMMARY_ROW_EDIT: {
      return (canEdit &&
        <div className="col-xs-6 slimv_element text-right bg-white">
          <a className={editClasses} href={`${editLink}?redirectTo=/summary`} onClick={handleTrackEvent}>
            Edit
            <i className="material-icons">mode_edit</i>
          </a>
        </div>
      );
    }
    default: return <div />;
  }
};

SummaryDetailValue.propTypes = {
  keyValue: PropTypes.string.isRequired,
  valueType: PropTypes.string.isRequired,
  value: PropTypes.string,
  authToken: PropTypes.string.isRequired,
  canEdit: PropTypes.bool,
  editClasses: PropTypes.string,
  editLink: PropTypes.string,
  applicationId: PropTypes.string,
  registration: PropTypes.shape(),
  application: PropTypes.shape(),
  accountType: PropTypes.shape(),
};

export default SummaryDetailValue;
